
import axios from "axios";
import apiUrl from "../../../constants";
import { createClearInputWatcher } from "../../../common/inputStyleHelper";
import dummyInput from '../common/smartInput.vue'
import CryptoJS from 'crypto-js';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ShipmentSearch',
  components: {
    'dummy-input': dummyInput,
    PageTracker
  },
   mixins:[PageTracker],
  data() {
    return {
      shipmentNo: "",
      lastmiledata: null,
      key: 0,
      isLoading: false,
      isTableLoading: 0,
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
      userDataKey:'',
    
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.username = userdetail.username

  },
  watch: {
    shipmentNo: createClearInputWatcher('shipmentNo'),
  },
  methods: {
    getpriorityinfo(awbNumber) {
      this.isShowDummyInput = false;
      if (!awbNumber || awbNumber.trim() === "") {
        this.$alertify.error("Please enter a valid AWB number");
        return;
      }
      const input = {
        ShippingID: awbNumber,
        requestFrom: "WEB",
        requestedBy:   this.localusermailid
      };

      this.styleData = null;
      this.lastmiledata = null;
      axios({
        method: 'post',
        url: apiUrl.api_url + 'search/shipment/priority',
        data: input,

      }).then(result => {
        if (result.data.code === 200) {
          this.isLoading = true;
          this.isShowDummyInput = true;
          this.styleData = result.data.lossCategorization;
          this.lastmiledata = result.data.data;
        }
        else {
          this.styleData = null;
          this.$alertify.error(result.data.message)
        }
      })

    },
    resetForm() {
      this.$refs.dummyShipInputBox.clearStyles();
      this.shipmentNo = "";
      this.styleData = null;
      this.lastmiledata = null;
      this.key += 1;
      this.isLoading = false;
    }
    // Helper: choose white or black text based on background brightness

  }
}


// WEBPACK FOOTER //
// ./src/views/components/ShipmnetSearch/ShipmentSearch.component.js